import type { CustomerResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Grid2, Typography } from "@mui/material";

type CustomerWidgetProps = {
	customer: CustomerResponseDto;
};

const infoResources = Resources.base.order.detail.info;

export function CustomerWidget({ customer }: CustomerWidgetProps) {
	const { t } = useResource();
	const { name, email, phone } = customer;

	return (
		<BaseCard title={t(infoResources.titleCustomer)}>
			<Grid2 container>
				<Grid2 size={12} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(infoResources.name)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{name}
					</Typography>
				</Grid2>

				<Grid2 size={12} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(infoResources.phone)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{phone}
					</Typography>
				</Grid2>

				<Grid2 size={12} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(infoResources.email)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{email}
					</Typography>
				</Grid2>
			</Grid2>
		</BaseCard>
	);
}
